import { AboutSection } from "./AboutSection";
import { BigPick } from "./BigPick";

export const AboutBody = () => {
    const info = {
        me: {
            title: "Dragonshifty Studios",
            text: "At the start of 2022 I decided to revisit an area of my life that I hadn't explored since my teens - programming. I once again fell in love with it and the pure creative possibilities. I could finally combine a lot of the other elements of my life that I had focused hard on over the years. This culminated in the creation of Dragonshifty Studios in 2023 with the release of Diffrentia on the Google Play store. The name Dragonshifty comes from my love of dragons and the 'shifty' trick in snowboarding.",
        },
        site: {
            title: "This site",
            text: "This is the first site I've written in React. It uses SASS, Bootstrap 5, and is written in Typescript. For all it's annoying strictness, I decided to use Typescript as it's more akin to my home language of Java (which also caused me a considerable amount of pain).",
        },
        rightNote: {
            title: "Hitting the Right Note*",
            text: "In early 2024 I was asked by Dr. Kate Whitman if I could do a data scrape from various music venue websites, detailing the performers and other aspects such as venue capacity and genre. From the return data it was evident there was a clear weighting towards male performers throughout these venues. Dr. Whitman and her fellow team members, Professor Samantha Parsley and Dr. Joe Cox, then decided to further explore this information with a series of surveys where the participants would listen to music with female and male versions in a controlled manner and asked questions regarding their preferences. Another part of the survey asked questions of instrumental pieces, such as what they thought the composer/performer looked like. As I analysed some of this data coming back in it was a pretty strange experience having people guess what I actually look like! It was a great honour for me to be a co-author on this paper, and the results (of which haven't been published yet) are quite startling. See links section for reference. *This is a working title and will be subject to change.",
        },
        davesDay: {
            title: "How Did Dave's Day Go?",
            text: "Dave's Day was originally written in Java to explore various design patterns but, as with most of my programs, I wanted to add a story element to it. At the time I was becoming increasingly frustrated with a mentor I was supposed to have that wouldn't look at any of my code. I therefore wrote a program where the output is minimal and you had to look at the code to see the story (don't think he ever did though). When converting this version to Typescript/React I've added more clues as to what adds to his stress system. Spread across three working shifts throughout the day, customer come in and order, waiters serve, bartenders make cocktails, and chefs cook - all real (digital) items. Some things Dave likes and dislikes affect his mood, such as staff member interactions, certain ingredients, what he thinks is fair, etc. The addition of random events for this version do not affect his mood as, by and large, it's the culmination of the small things that can make or break our days.",
        },
        diffrentia: {
            title: "Diffrentia",
            text: "Before Diffrentia I wrote a small game called Matrix Wars. I was playing about with various game rules and it had a similar points system based on the difference between two scores. It soon became evident that the rules were far too complicated. For Diffrentia I stripped everything back for a more simplistic and enjoyable game. It was also important that the game can be played with a normal pack of cards (and a piece of paper or, ideally, a cribbage board for scoring). I also wanted to have a weekly target that people can build up and look forward to. The name is a play on words on 'difference' (scoring) and 'differentia' - 'a distinguishing mark or characteristic' (the different clans). Diffrentia is written in Unity.",
        },
    };

    return (
        <>
            <header
                className="header vh-100 text-center position-relative"
                style={{
                    backgroundImage: "url(../../images/dragon-bg2.jpg)",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundAttachment: "fixed",
                    backgroundRepeat: "no-repeat",
                    paddingTop: "2rem",
                }}
            >
                <div className="text-container position-relative d-flex flex-column justify-content-center align-items center h-100">
                    <h5 className="text-primary fs-3fw bold text-uppercase">
                        About
                    </h5>
                    <h1 className="display-1 fw-bold text-white">
                        Dragonshifty Studios
                    </h1>
                    <p className="roles text-primary text-uppercase fs-4">
                        <span>Programming | </span>
                        <span>music | </span>
                        <span>graphics</span>
                    </p>
                </div>
            </header>
            <section className="details bg-dark ">
                <div className="container">
                    <div>
                        <div className="col p-3 img-fluid d-flex justify-content-center text-center">
                            <img
                                className="mx-2 img-fluid"
                                src="../images/DS-emb2.png"
                                alt="Logo"
                                width="400px"
                            />
                        </div>
                    </div>
                    <div className="row pt-4 ">
                        <AboutSection
                            title={info.me.title}
                            text={info.me.text}
                            showLinks={false}
                        />
                        <AboutSection
                            title={info.site.title}
                            text={info.site.text}
                            showLinks={false}
                        />
                        <AboutSection
                            title={info.davesDay.title}
                            text={info.davesDay.text}
                            showLinks={false}
                        />
                        <AboutSection
                            title={info.diffrentia.title}
                            text={info.diffrentia.text}
                            showLinks={false}
                        />
                        <AboutSection
                            title={info.rightNote.title}
                            text={info.rightNote.text}
                            showLinks={true}
                        />
                    </div>
                </div>
            </section>

            <BigPick />
        </>
    );
};
